import { useEffect } from 'react';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

/**
 * Reveals `.tl-reveal` blocks once as they enter the viewport.
 *
 * The hidden state lives behind the `tl-motion-ready` class on <html>, which is
 * only applied when an IntersectionObserver is available and motion is welcome.
 * Every other path leaves the page fully rendered.
 */
export const useReveal = (prefersReducedMotionOverride) => {
  const prefersReducedMotionFromMedia = usePrefersReducedMotion();
  const prefersReducedMotion =
    prefersReducedMotionOverride === undefined
      ? prefersReducedMotionFromMedia
      : prefersReducedMotionOverride;

  useEffect(() => {
    const root = document.documentElement;

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      root.classList.remove('tl-motion-ready');
      return undefined;
    }

    root.classList.add('tl-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    const elements = Array.from(document.querySelectorAll('.tl-reveal'));
    elements.forEach((element) => observer.observe(element));

    return () => {
      observer.disconnect();
      root.classList.remove('tl-motion-ready');
    };
  }, [prefersReducedMotion]);
};
